import { render, staticRenderFns } from "./main-footer.vue?vue&type=template&id=056d9ea4"
import script from "./main-footer.vue?vue&type=script&lang=ts"
export * from "./main-footer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports